import { Customer } from './customer';
import { RequestPayload, ResponsePayload } from './request';

export enum UserActions {
  LOGIN = 'LOGIN',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_FAIL = 'LOGIN_FAIL',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS',
  LOGOUT = 'LOGOUT',
  FETCH_ADMINS = 'FETCH_ADMINS',
  FETCH_ADMINS_SUCCESS = 'FETCH_ADMINS_SUCCESS',
  CREATE_ADMIN_USER = 'CREATE_ADMIN_USER',
  CREATE_ADMIN_USER_SUCCESS = 'CREATE_ADMIN_USER_SUCCESS',
  UPDATE_ADMIN_USER = 'UPDATE_ADMIN_USER',
  UPDATE_ADMIN_USER_SUCCESS = 'UPDATE_ADMIN_USER_SUCCESS'
}

interface UserActionType<T, P> {
  type: T;
  payload: P;
}

export interface User {
  id: number;
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  role: string;
  isActive: boolean;
  imperial: boolean;
  customer: Customer;
  language: string;
  canTriggerStockExport: boolean;
  supportCustomers?: Customer[]
}

export interface UserLoginPayload {
  refreshToken: string;
  accessToken: string;
  user: any;
}

export type UserAction =
  | UserActionType<typeof UserActions.LOGIN, RequestPayload>
  | UserActionType<
    typeof UserActions.LOGIN_SUCCESS,
    ResponsePayload<UserLoginPayload>
  >
  | UserActionType<typeof UserActions.REFRESH_TOKEN, RequestPayload>
  | UserActionType<
    typeof UserActions.REFRESH_TOKEN_SUCCESS,
    ResponsePayload<UserLoginPayload>
  >
  | UserActionType<typeof UserActions.LOGOUT, null>
  | UserActionType<typeof UserActions.LOGIN_FAIL, null>
  | UserActionType<typeof UserActions.FETCH_ADMINS, RequestPayload>
  | UserActionType<
    typeof UserActions.FETCH_ADMINS_SUCCESS,
    ResponsePayload<User[]>
  >
  | UserActionType<typeof UserActions.CREATE_ADMIN_USER, RequestPayload>
  | UserActionType<
    typeof UserActions.CREATE_ADMIN_USER_SUCCESS,
    ResponsePayload<User>
  >
  | UserActionType<typeof UserActions.UPDATE_ADMIN_USER, RequestPayload>
  | UserActionType<
    typeof UserActions.UPDATE_ADMIN_USER_SUCCESS,
    ResponsePayload<User>
  >
